import { render, staticRenderFns } from "./AllGames.vue?vue&type=template&id=f5617634"
import script from "./AllGames.vue?vue&type=script&lang=js"
export * from "./AllGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QPageScroller from 'quasar/src/components/page-scroller/QPageScroller.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinner,QIntersection,QPageScroller,QBtn});
